module.exports = __webpack_public_path__ + "img/rating-page-text.dd41461a.svg";